import React from 'react';

export default function DesktopNavbar() {
  return <></>;
}
